import script from "./DesktopCameraCapture.vue?vue&type=script&setup=true&lang=js"
export * from "./DesktopCameraCapture.vue?vue&type=script&setup=true&lang=js"

import "./DesktopCameraCapture.vue?vue&type=style&index=0&id=7a6a4900&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a6a4900"]])

export default __exports__